export const YES_NO_CHECK_IN_SCHEMAS: ReadonlySet<string> = new Set([
  'behavioral-realtime-episodic',
]);
/** Known capture semantics; unknown registry keys must never invent an answer. */
export function resolveUsageCaptureMode(schema: string): 'counter' | 'yes-no' | null {
  if (schema === 'substance-retrospective-quantified') return 'counter';
  if (YES_NO_CHECK_IN_SCHEMAS.has(schema)) return 'yes-no';
  return null;
}

export function isYesNoCheckInSchema(schema: string): boolean {
  return resolveUsageCaptureMode(schema) === 'yes-no';
}
